import {
    //CONFIGURATION
    CONFIGURATION_REQUEST, CONFIGURATION_SUCCESS, CONFIGURATION_FAILURE, SET_CLIENT_CONTEXT,
    // SIGN IN TYPE
    SIGN_IN_REQUEST, SIGN_IN_SUCCESS, SIGN_IN_FAILURE,
    // SIGN IN GUEST
    SIGN_IN_GUEST_REQUEST, SIGN_IN_GUEST_SUCCESS, SIGN_IN_GUEST_FAILURE,
    // SIGN UP    
    SIGN_UP_REQUEST, SIGN_UP_SUCCESS, SIGN_UP_FAILURE,
    //BANNERS LIST
    BANNERS_LIST_REQUEST, BANNERS_LIST_SUCCESS, BANNERS_LIST_FAILURE,
    //SEGMENT_LIST
    SEGMENT_LIST_REQUEST, SEGMENT_LIST_SUCCESS, SEGMENT_LIST_FAILURE,
    //STORES_LIST
    STORES_LIST_REQUEST, STORES_LIST_SUCCESS, STORES_LIST_FAILURE,
    //RECENTLY BROWSE
    RECENTLY_BROWSE_REQUEST, RECENTLY_BROWSE_SUCCESS, RECENTLY_BROWSE_FAILURE,
    //PREVIOUS ORDERS LIST
    GET_PREVIOUS_ORDERS_REQUEST, GET_PREVIOUS_ORDERS_SUCCESS, GET_PREVIOUS_ORDERS_FAILURE,
    //LAST ORDER SEGMENT
    GET_LAST_ORDER_SEGMENT_REQUEST, GET_LAST_ORDER_SEGMENT_SUCCESS, GET_LAST_ORDER_SEGMENT_FAILURE,
    //BRAND LIST
    GET_BRAND_LIST_REQUEST, GET_BRAND_LIST_SUCCESS, GET_BRAND_LIST_FAILURE,
    //ORDERS LIST
    GET_ORDERS_LIST_REQUEST, GET_ORDERS_LIST_SUCCESS, GET_ORDERS_LIST_FAILURE,
    //ORDERS DETAIL
    GET_ORDERS_DETAIL_REQUEST, GET_ORDERS_DETAIL_SUCCESS, GET_ORDERS_DETAIL_FAILURE,
    //TRACK ORDERS DETAIL
    TRACK_ORDERS_DETAIL_REQUEST, TRACK_ORDERS_DETAIL_SUCCESS, TRACK_ORDERS_DETAIL_FAILURE,
    //ORDER CANCEL
    GET_ORDER_CANCEL_REQUEST, GET_ORDER_CANCEL_SUCCESS, GET_ORDER_CANCEL_FAILURE,
    //RE ORDER
    RE_ORDER_REQUEST, RE_ORDER_SUCCESS, RE_ORDER_FAILURE,
    //GET ITEMS FOR RETURN
    GET_ITEMS_FOR_RETURN_REQUEST, GET_ITEMS_FOR_RETURN_SUCCESS, GET_ITEMS_FOR_RETURN_FAILURE,
    //RETURN ITEMS
    RETURN_ITEMS_REQUEST, RETURN_ITEMS_SUCCESS, RETURN_ITEMS_FAILURE,
    //VIEW SUBSITUTION DETAIL
    VIEW_SUBSITUTION_DETAIL_REQUEST, VIEW_SUBSITUTION_DETAIL_SUCCESS, VIEW_SUBSITUTION_DETAIL_FAILURE,
    //SUBMIT SUBSITUTION DETAIL
    SUBMIT_SUBSITUTION_DETAIL_REQUEST, SUBMIT_SUBSITUTION_DETAIL_SUCCESS, SUBMIT_SUBSITUTION_DETAIL_FAILURE,
    //ORDER CANCEL REASON
    GET_ORDER_CANCEL_REASON_REQUEST, GET_ORDER_CANCEL_REASON_SUCCESS, GET_ORDER_CANCEL_REASON_FAILURE,
    //REPORT ISSUE ADD
    ADD_REPORT_ISSUE_REQUEST, ADD_REPORT_ISSUE_SUCCESS, ADD_REPORT_ISSUE_FAILURE,
    //GET REPORT ISSUE REASON
    GET_REPORT_ISSUE_REASON_REQUEST, GET_REPORT_ISSUE_REASON_SUCCESS, GET_REPORT_ISSUE_REASON_FAILURE,
    //GET SOS LIST
    GET_SOS_LIST_REQUEST, GET_SOS_LIST_SUCCESS, GET_SOS_LIST_FAILURE,
    // FOR GET REFER DETAILS
    GET_REFER_DETAILS_REQUEST, GET_REFER_DETAILS_SUCCESS, GET_REFER_DETAILS_FAILURE,
    //USER UPDATE PASSWORD
    USER_UPDATE_PASSWORD_REQUEST, USER_UPDATE_PASSWORD_SUCCESS, USER_UPDATE_PASSWORD_FAILURE,
    //GET PRODUCT RATE
    GET_PRODUCT_RATE_REQUEST, GET_PRODUCT_RATE_SUCCESS, GET_PRODUCT_RATE_FAILURE,
    //POST ORDER RATE
    GET_ORDER_RATE_REQUEST, GET_ORDER_RATE_SUCCESS, GET_ORDER_RATE_FAILURE,
    //SAVE PRODUCT CART
    SAVE_PRODUCT_CART_REQUEST, SAVE_PRODUCT_CART_SUCCESS, SAVE_PRODUCT_CART_FAILURE,
    //GET PRODUCT CART
    GET_PRODUCT_CART_REQUEST, GET_PRODUCT_CART_SUCCESS, GET_PRODUCT_CART_FAILURE,
    //GET PROMO CODE LIST
    GET_PROMO_CODE_LIST_REQUEST, GET_PROMO_CODE_LIST_SUCCESS, GET_PROMO_CODE_LIST_FAILURE,
    //APPLY REMOVE_PROMO_CODE
    APPLY_REMOVE_PROMO_CODE_REQUEST, APPLY_REMOVE_PROMO_CODE_SUCCESS, APPLY_REMOVE_PROMO_CODE_FAILURE,
    //GET CART RELATED ITEM LIST
    GET_CART_RELATEDITEM_LIST_REQUEST, GET_CART_RELATEDITEM_LIST_SUCCESS, GET_CART_RELATEDITEM_LIST_FAILURE,
    //GET USER DATA
    GET_USERDATA_REQUEST, GET_USERDATA_SUCCESS, GET_USERDATA_FAILURE,
    //EDIT USER DATA
    EDIT_USERDATA_REQUEST, EDIT_USERDATA_SUCCESS, EDIT_USERDATA_FAILURE,
    LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE,
    //CHANGE PASSWORD
    CHANGE_PASSWORD_REQUEST, CHANGE_PASSWORD_SUCCESS, CHANGE_PASSWORD_FAILURE,
    //EDIT PROFILE
    EDIT_PROFILE_REQUEST, EDIT_PROFILE_SUCCESS, EDIT_PROFILE_FAILURE,

    TRIGGERS_LIST_UNDER_REQUEST, TRIGGERS_LIST_UNDER_SUCCESS, TRIGGERS_LIST_UNDER_FAILURE,
    TRIGGERS_UPDATE_REQUEST, TRIGGERS_UPDATE_SUCCESS, TRIGGERS_UPDATE_FAILURE,
    //create address
    TRIGGERS_CREATE_REQUEST, TRIGGERS_CREATE_SUCCESS, TRIGGERS_CREATE_FAILURE,
    //Delete address
    TRIGGERS_DELETE_REQUEST, TRIGGERS_DELETE_SUCCESS, TRIGGERS_DELETE_FAILURE,
    // FOR GET CATEGORIES BY STORE
    GET_CATEGOURIES_REQUEST, GET_CATEGOURIES_SUCCESS,GET_CATEGOURIES_FAILURE,
    // FOR GET SUB CATEGORIES BY STORE
    GET_SUBCATEGOURIES_REQUEST, GET_SUBCATEGOURIES_SUCCESS,GET_SUBCATEGOURIES_FAILURE,
    // FOR GET STORE DETAIL
    GET_STOREDETAIL_REQUEST, GET_STOREDETAIL_SUCCESS, GET_STOREDETAIL_FAILURE,
    // FOR GET CATEGORY PRODUCT
    GET_CATEGORY_PRODUCT_REQUEST, GET_CATEGORY_PRODUCT_SUCCESS, GET_CATEGORY_PRODUCT_FAILURE,
    GET_PRODUCT_DETAILS_REQUEST, GET_PRODUCT_DETAILS_SUCCESS, GET_PRODUCT_DETAILS_FAILURE,
    // FOR PLACE ORDER
    PLACE_ORDER_REQUEST, PLACE_ORDER_SUCCESS, PLACE_ORDER_FAILURE, SET_LOCATION,
    //GET SOCIAL LINKS
    GET_SOCIAL_LINKS_REQUEST, GET_SOCIAL_LINKS_SUCCESS, GET_SOCIAL_LINKS_FAILURE,

    RESET_DATA, OPEN_MODAL, CLOSE_MODAL, CLOSE_ALL_MODALS,

    CART_CLEAR

} from './action-types';
import axiosInstance, { API_ENV_STORAGE_KEY } from '../../axios/axiosinstance';
import { API_PUBLIC_KEY } from '../../config/api';
import { buildClientContext } from '../../utils/clientContext';
import { isAuthenticationFailure } from '../../utils/authentication';
import { getSegmentId, getSegmentItems, isSeparateServiceSegment, isShoppingSegment } from '../../utils/segmentFlow';
import {
    DEFAULT_DELIVERY_LOCATION,
    LOCATION_STORAGE_KEY,
    enrichLocationWithMarketMetadata,
    isGuestDefaultLocation,
} from '../../utils/locationDefaults';

const CART_ID_STORAGE_KEY = "cart_id";
let saveCartRequestSequence = 0;
const DEFAULT_CART_LOCATION = DEFAULT_DELIVERY_LOCATION;

const hasValue = (value) => value !== null && value !== undefined && value !== "";

const isPlainObject = (value) =>
    value && typeof value === "object" && !Array.isArray(value);

const parseJsonValue = (value) => {
    if (typeof value !== "string") return value;

    try {
        return JSON.parse(value);
    } catch (error) {
        return value;
    }
};

const isSuccessResponse = (responseJson) =>
    responseJson?.result === true || responseJson?.result === 1 || responseJson?.result === "1";

const getValue = (item, keys) => {
    const matchedKey = keys.find((key) => hasValue(item?.[key]));

    return matchedKey ? item[matchedKey] : "";
};

const getCellContents = (data) => {
    return Array.isArray(data?.cell_contents) ? data.cell_contents : [];
};

const getLocalStorageItem = (key) => {
    try {
        return localStorage.getItem(key);
    } catch (error) {
        return null;
    }
};

const setLocalStorageItem = (key, value) => {
    try {
        if (hasValue(value)) {
            localStorage.setItem(key, value);
        }
    } catch (error) {
        // localStorage can be unavailable in restricted browser contexts.
    }
};

const removeLocalStorageItem = (key) => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        // localStorage can be unavailable in restricted browser contexts.
    }
};

const pendingReadRequests = new WeakMap();

const shareReadRequest = (dispatch, endpoint, data, request) => {
    const entries = typeof data?.entries === "function"
        ? Array.from(data.entries())
        : isPlainObject(data) ? Object.entries(data) : null;

    // Share only simple read payloads whose values can be compared reliably.
    if (!entries || entries.some(([, value]) => value !== null && typeof value === "object")) {
        return request();
    }

    const key = JSON.stringify([
        axiosInstance.defaults?.baseURL,
        getLocalStorageItem(API_ENV_STORAGE_KEY),
        getLocalStorageItem("access_token"),
        endpoint,
        entries.sort(([left], [right]) => left.localeCompare(right)),
    ]);
    let requests = pendingReadRequests.get(dispatch);
    if (!requests) {
        requests = new Map();
        pendingReadRequests.set(dispatch, requests);
    }
    if (requests.has(key)) return requests.get(key);

    const promise = Promise.resolve().then(request).finally(() => {
        if (requests.get(key) === promise) requests.delete(key);
    });
    requests.set(key, promise);
    return promise;
};

const getSavedUserLocation = () => {
    try {
        const savedLocation = getLocalStorageItem(LOCATION_STORAGE_KEY);
        return savedLocation ? JSON.parse(savedLocation) : null;
    } catch (error) {
        return null;
    }
};

const getActiveUserLocation = (state = {}) => {
    const auth = state.auth || {};
    const reduxLocation = auth.user_location || {};
    const savedLocation = getSavedUserLocation() || {};

    return {
        latitude:
            auth.latitude ??
            reduxLocation.latitude ??
            savedLocation.latitude ??
            DEFAULT_CART_LOCATION.latitude,
        longitude:
            auth.longitude ??
            reduxLocation.longitude ??
            savedLocation.longitude ??
            DEFAULT_CART_LOCATION.longitude,
        merchant_id:
            getValue(reduxLocation, ["merchant_id", "merchantId"]) ||
            getValue(savedLocation, ["merchant_id", "merchantId"]) ||
            DEFAULT_CART_LOCATION.merchant_id,
    };
};

const getCartIdFromPayload = (payload) => {
    const data = Array.isArray(payload?.data) ? payload.data[0] : payload?.data;
    const responseData = Array.isArray(data?.response_data)
        ? data.response_data[0]
        : data?.response_data;
    const cartData =
        data?.cart ||
        data?.cart_data ||
        data?.cart_details ||
        responseData ||
        data ||
        payload?.cart ||
        payload?.cart_data ||
        payload;

    return getValue(cartData, ["cart_id", "cartId", "id"]);
};

const getActiveCartId = (state = {}) => {
    return (
        state.cart?.cartId ||
        state.cart?.serverCartSummary?.cart_id ||
        getCartIdFromPayload(state.cart?.data) ||
        getCartIdFromPayload(state.common?.cartData) ||
        ""
    );
};

const persistCartIdFromResponse = (responseJson) => {
    const cartId = getCartIdFromPayload(responseJson);
    setLocalStorageItem(CART_ID_STORAGE_KEY, cartId);

    return cartId;
};

const getItemId = (item) =>
    String(item?.product_variant_id || item?.variant_id || item?.product_id || item?.id || "");

const getItemPortion = (item = {}) =>
    getValue(item, [
        "portion",
        "product_portion",
        "productPortion",
        "selected_portion",
        "selectedPortion",
        "portion_name",
        "portionName",
    ]) ||
    getValue(item?.product, ["portion", "product_portion", "productPortion"]) ||
    getValue(item?.product_detail, ["portion", "product_portion", "productPortion"]) ||
    getValue(item?.variant, ["portion", "product_portion", "productPortion"]) ||
    getValue(item?.variant_detail, ["portion", "product_portion", "productPortion"]) ||
    getValue(item?.product_variant, ["portion", "product_portion", "productPortion"]) ||
    "";

const normalizeCartItem = (item = {}) => {
    const id = getItemId(item);

    return {
        id,
        product_variant_id: item.product_variant_id || item.variant_id || item.product_id || item.id || id,
        name: item.name || item.title || item.product_name || item.product_title || "Product",
        price: Number(
            item.price ??
            item.product_price ??
            item.selling_price ??
            item.product_selling_price ??
            item.product_cost ??
            item.final_price ??
            item.discounted_price ??
            0
        ),
        quantity: Number(item.quantity || 1),
        image: item.image || item.product_cover_image || "assets/images/thumbs/product-two-img1.png",
        currency: item.currency || "INR",
        rating: item.rating,
        segment_id: getValue(item, ["segment_id", "segmentId", "segment"]),
        business_segment_id: getValue(item, [
            "business_segment_id",
            "businessSegmentId",
            "store_id",
            "storeId",
            "branch_id",
        ]),
        portion: getItemPortion(item) || null,
        unit: item.unit || item.weight_unit || "",
        merchant_id: getValue(item, ["merchant_id", "merchantId"]) || null,
        empty_bottle_count: item.empty_bottle_count ?? item.emptyBottleCount ?? null,
        arr_option_id: item.arr_option_id ?? item.arrOptionId ?? null,
        options: item.options || "",
    };
};

const getCartContextValue = (state, keys) =>
    getValue(state.cart?.data, keys) ||
    getValue(parseJsonValue(state.cart?.data?.receipt), keys) ||
    getValue(state.cart?.lastSaveCartPayload, keys);

const getDynamicSegmentId = (state = {}, changedItem = {}, cartItems = []) => {
    const itemSegmentId =
        getValue(changedItem, ["segment_id", "segmentId", "segment"]) ||
        getValue(cartItems.find((item) => getValue(item, ["segment_id", "segmentId", "segment"])), [
            "segment_id",
            "segmentId",
            "segment",
        ]);

    if (itemSegmentId) {
        return itemSegmentId;
    }

    const cartSegmentId = getCartContextValue(state, ["segment_id", "segmentId", "segment"]);
    if (cartSegmentId) return cartSegmentId;

    const servicesData = state.common?.servicesData;
    const directSegmentId = getValue(servicesData, ["id", "segment_id", "segmentId"]);

    if (isShoppingSegment(servicesData) && directSegmentId && Number(directSegmentId) !== 0) {
        return directSegmentId;
    }

    const selectedSegment = getCellContents(servicesData).find((item) => {
        const id = getValue(item, ["id", "segment_id", "segmentId"]);
        return isShoppingSegment(item) && id && Number(id) !== 0;
    });

    return getValue(selectedSegment, ["id", "segment_id", "segmentId"]);
};

const getDynamicBusinessSegmentId = (state = {}, changedItem = {}, cartItems = []) => {
    const businessSegmentKeys = [
        "business_segment_id",
        "businessSegmentId",
        "business_segment",
        "businessSegment",
        "store_id",
        "storeId",
        "branch_id",
    ];
    const itemBusinessSegmentId =
        getValue(changedItem, businessSegmentKeys) ||
        getValue(cartItems.find((item) => getValue(item, businessSegmentKeys)), businessSegmentKeys);

    if (itemBusinessSegmentId) {
        return itemBusinessSegmentId;
    }

    const cartBusinessSegmentId = getCartContextValue(state, businessSegmentKeys);
    if (cartBusinessSegmentId) return cartBusinessSegmentId;

    const storesData = state.common?.storesData;
    const directBusinessSegmentId = getValue(storesData, businessSegmentKeys);

    if (directBusinessSegmentId) {
        return directBusinessSegmentId;
    }

    const selectedStore = getCellContents(storesData).find((item) =>
        getValue(item, businessSegmentKeys)
    );

    return getValue(selectedStore, businessSegmentKeys);
};

const buildSaveCartFormData = (payload) => {
    const formData = new FormData();
    const requiredSaveCartKeys = [
        "business_segment_id",
        "cart_id",
        "empty_bottle_count",
        "arr_option_id",
        "home_or_office",
        "latitude",
        "longitude",
        "product_details",
        "product_update",
        "product_variant_id",
        "quantity",
        "reward_points",
        "segment_id",
        "single_product",
        "merchant_id",
        "area",
        "for",
        "distance",
        "cart_amount",
        "portion",
    ];

    Object.entries(payload).forEach(([key, value]) => {
        if (!hasValue(value)) {
            if (requiredSaveCartKeys.includes(key)) {
                // Multipart has no null value; Laravel converts empty fields to null.
                formData.append(key, "");
            }
            return;
        }

        if (key === "product_details") {
            formData.append(key, typeof value === "string" ? value : JSON.stringify(value));
            return;
        }

        formData.append(key, value);
    });

    return formData;
};

const normalizeProductDetailsPortion = (productDetails) => {
    const parsedProductDetails = parseJsonValue(productDetails);

    if (!Array.isArray(parsedProductDetails)) {
        return productDetails;
    }

    return parsedProductDetails.map((item) => {
        if (!isPlainObject(item)) return item;

        return {
            ...item,
            portion: getItemPortion(item),
        };
    });
};

const getMatchingProductDetailPortion = (productDetails, productVariantId) => {
    if (!Array.isArray(productDetails)) {
        return "";
    }

    const matchedProduct = productDetails.find((item) => {
        if (!isPlainObject(item)) return false;

        return String(getItemId(item)) === String(productVariantId || "");
    });
    const productDetail = matchedProduct || (productDetails.length === 1 ? productDetails[0] : null);

    return getItemPortion(productDetail);
};

const normalizeSaveCartPayload = (payload = {}, merchantId = 1) => {
    const productDetails = normalizeProductDetailsPortion(payload?.product_details);
    const productVariantId = payload?.product_variant_id || payload?.variant_id || payload?.product_id || payload?.id;
    const matchedPortion = getMatchingProductDetailPortion(
        productDetails,
        productVariantId
    );
    const portion = payload?.portion !== undefined ? payload.portion : matchedPortion;
    const nullableFields = {
        portion: hasValue(portion) ? portion : null,
        empty_bottle_count: hasValue(payload?.empty_bottle_count) ? payload.empty_bottle_count : null,
        arr_option_id: hasValue(payload?.arr_option_id) ? payload.arr_option_id : null,
        merchant_id: hasValue(payload?.merchant_id) ? payload.merchant_id : merchantId,
    };

    if (payload?.single_product === "YES" || (hasValue(productVariantId) &&
        Number(productVariantId) !== 0 && payload?.single_product !== "NO")) {
        return {
            quantity: payload.quantity ?? 1,
            product_update: "YES",
            business_segment_id: payload.business_segment_id,
            ...nullableFields,
            single_product: "YES",
            product_variant_id: productVariantId,
            segment_id: payload.segment_id,
        };
    }

    // Verification and bulk reorders retain their read/bulk request fields.
    return {
        ...(payload || {}),
        ...nullableFields,
        product_details: productDetails,
    };
};

const getNextCartItemsAfterAdd = (cartItems, item) => {
    const existingItem = cartItems.find((cartItem) => getItemId(cartItem) === item.id);

    if (existingItem) {
        return cartItems.map((cartItem) =>
            getItemId(cartItem) === item.id
                ? {
                    ...cartItem,
                    ...(item.portion !== cartItem.portion
                        ? { portion: item.portion, unit: item.unit, price: item.price }
                        : {}),
                    quantity: Number(cartItem.quantity || 0) + Number(item.quantity || 1),
                }
                : cartItem
        );
    }

    return [...cartItems, item];
};

const buildSaveProductCartPayload = ({
    state,
    nextCartItems,
    changedItem,
    cartId,
}) => {
    const userLocation = getActiveUserLocation(state);
    const productVariantId = changedItem.product_variant_id || changedItem.id;
    const nextChangedItem = nextCartItems.find(
        (item) => String(item.product_variant_id || item.id) === String(productVariantId)
    );
    const changedQuantity = nextChangedItem?.quantity ?? changedItem.quantity ?? 0;
    const changedPortion = getItemPortion(nextChangedItem) || getItemPortion(changedItem);
    const payload = {
        single_product: "YES",
        segment_id: getDynamicSegmentId(state, changedItem, nextCartItems),
        business_segment_id: getDynamicBusinessSegmentId(state, changedItem, nextCartItems),
        product_update: "YES",
        product_variant_id: productVariantId,
        portion: changedPortion || null,
        quantity: Number(changedQuantity || 0),
        empty_bottle_count: changedItem.empty_bottle_count ?? null,
        arr_option_id: changedItem.arr_option_id ?? null,
        merchant_id: changedItem.merchant_id || userLocation.merchant_id,
    };

    if (cartId) {
        payload.cart_id = cartId;
    }

    return payload;
};

const saveCartAfterLocalChange = async ({
    dispatch,
    state,
    nextCartItems,
    changedItem,
    cartId,
}) => {
    const payload = buildSaveProductCartPayload({
        state,
        nextCartItems,
        changedItem,
        cartId,
    });

    try {
        return await dispatch(getSaveProductCart(payload, { cartId, cartItems: nextCartItems }));
    } catch (error) {
        console.log("Save cart API Error:", error?.message || error);
        return null;
    }
};

export const setClientContext = (clientContext) => ({
    type: SET_CLIENT_CONTEXT,
    payload: clientContext,
});

export const initializeClientContext = () => (dispatch) => {
    const clientContext = buildClientContext();
    dispatch(setClientContext(clientContext));
    return clientContext;
};

// FOR GET CONFIGURATION DATA
export function getConfiguration(data = {}) {
    return async (dispatch, getState) => {
        dispatch({ type: CONFIGURATION_REQUEST });
        try {
            const clientContext = getState()?.common?.clientContext || buildClientContext();
            const requestData = {
                ...clientContext,
                ...data,
            };

            var response = await axiosInstance.post(`web/configuration`, requestData, {
                headers: {
                    publicKey: API_PUBLIC_KEY,
                },
            });
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: CONFIGURATION_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: CONFIGURATION_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: CONFIGURATION_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR USER SIGN IN
export function signIn(data) {
    return async (dispatch) => {
        dispatch({ type: SIGN_IN_REQUEST });
        try {
            var response = await axiosInstance.post(`web/login`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                const savedLocation = parseJsonValue(getLocalStorageItem(LOCATION_STORAGE_KEY));

                if (isGuestDefaultLocation(savedLocation)) {
                    removeLocalStorageItem(LOCATION_STORAGE_KEY);
                }

                dispatch({ type: SIGN_IN_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: SIGN_IN_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: SIGN_IN_FAILURE, payload: error });
            return Promise.reject(error)
        }
    };
}
// FOR USER GUEST SIGN IN
export function signInGuestUser(data) {
    const payload = {
        country_id: DEFAULT_DELIVERY_LOCATION.country_id,
        ...data,
    };

    return async (dispatch) => {
        dispatch({ type: SIGN_IN_GUEST_REQUEST });
        try {
            var response = await axiosInstance.post(`web/guest/login`, payload);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: SIGN_IN_GUEST_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: SIGN_IN_GUEST_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: SIGN_IN_GUEST_FAILURE, payload: error });
            return Promise.reject(error)
        }
    };
}

// FOR USER SIGN UP
export function signUp(data) {
    return async (dispatch) => {
        dispatch({ type: SIGN_UP_REQUEST });
        try {
            var response = await axiosInstance.post(`web/signup`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: SIGN_UP_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: SIGN_UP_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: SIGN_UP_FAILURE, payload: error });
            return Promise.reject(error)
        }
    };
}
// FOR GET BANNERS
export function getBannersList(data) {
    return (dispatch) => shareReadRequest(dispatch, "web/grocery/get-banners", data, async () => {
        dispatch({ type: BANNERS_LIST_REQUEST });
        try {
            const isUrlEncodedPayload =
                typeof URLSearchParams !== "undefined" && data instanceof URLSearchParams;
            var response = await axiosInstance.post(
                `web/grocery/get-banners`,
                data,
                isUrlEncodedPayload
                    ? { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
                    : undefined
            );
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: BANNERS_LIST_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: BANNERS_LIST_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: BANNERS_LIST_FAILURE, payload: error });
            return Promise.reject(error)
        }
    });
}

// FOR GET SEGMENT LIST
export function getSegments(data) {
    return (dispatch) => shareReadRequest(dispatch, "web/segments", data, async () => {
        dispatch({ type: SEGMENT_LIST_REQUEST });
        try {
            var response = await axiosInstance.post(`web/segments`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: SEGMENT_LIST_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: SEGMENT_LIST_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: SEGMENT_LIST_FAILURE, payload: error });
            return Promise.reject(error);
        }
    });
}

// FOR GET STORES LIST
export function getStores(data) {
    return async (dispatch) => {
        dispatch({ type: STORES_LIST_REQUEST });
        try {
            var response = await axiosInstance.post(`web/stores`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: STORES_LIST_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: STORES_LIST_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: STORES_LIST_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}
// FOR GET STORE DETAIL
export function getStoreDetail(data) {
    return async (dispatch) => {
        dispatch({ type: GET_STOREDETAIL_REQUEST });
        try {
            var response = await axiosInstance.post(`web/grocery/store-details`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_STOREDETAIL_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_STOREDETAIL_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_STOREDETAIL_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// RECENTLY BROWSE PRODUCT LIST
export function getRecentlyBrowseProduct(data) {
    return async (dispatch) => {
        dispatch({ type: RECENTLY_BROWSE_REQUEST });
        try {
            var response = await axiosInstance.post(`web/recently_browsed_products`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: RECENTLY_BROWSE_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: RECENTLY_BROWSE_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: RECENTLY_BROWSE_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}
// FOR GET PREVIOUS ORDERS LIST
export function getPreviousOrders(data) {
    return async (dispatch) => {
        dispatch({ type: GET_PREVIOUS_ORDERS_REQUEST });
        try {
            var response = await axiosInstance.post(`web/previous-orders`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: GET_PREVIOUS_ORDERS_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_PREVIOUS_ORDERS_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_PREVIOUS_ORDERS_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR GET LAST ORDER SEGMENT
export function getLastOrderSegment(data = {}) {
    return async (dispatch) => {
        dispatch({ type: GET_LAST_ORDER_SEGMENT_REQUEST });
        try {
            const response = await axiosInstance.post('user/grocery/get-last-order-segment', data);
            const responseJson = response.data;
            if (!isSuccessResponse(responseJson)) {
                throw responseJson;
            }
            dispatch({ type: GET_LAST_ORDER_SEGMENT_SUCCESS, payload: responseJson });
            return responseJson;
        } catch (error) {
            dispatch({ type: GET_LAST_ORDER_SEGMENT_FAILURE, payload: error });
            throw error;
        }
    };
}

// FOR GET STORE BRANDS LIST
export function getStoreBrands(data) {
    return async (dispatch) => {
        dispatch({ type: GET_BRAND_LIST_REQUEST });
        try {
            var response = await axiosInstance.post(`user/grocery/get-store-brands`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_BRAND_LIST_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_BRAND_LIST_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_BRAND_LIST_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}
// FOR GET ORDERS LIST
export function getOrdersList(data) {
    return async (dispatch) => {
        dispatch({ type: GET_ORDERS_LIST_REQUEST });
        try {
            var response = await axiosInstance.post(`web/get_orders`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                console.log("action-creqter", responseJson)
                dispatch({ type: GET_ORDERS_LIST_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_ORDERS_LIST_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_ORDERS_LIST_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR GET ORDER DETAIL
export function getOrderDetail(data) {
    return async (dispatch) => {
        dispatch({ type: GET_ORDERS_DETAIL_REQUEST });
        try {
            var response = await axiosInstance.post(`web/get_order_details`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_ORDERS_DETAIL_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_ORDERS_DETAIL_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_ORDERS_DETAIL_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR TRACK ORDER DETAIL
export function trackOrderDetail(data) {
    return async (dispatch) => {
        dispatch({ type: TRACK_ORDERS_DETAIL_REQUEST });
        try {
            var response = await axiosInstance.post(`user/track-order-details`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: TRACK_ORDERS_DETAIL_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: TRACK_ORDERS_DETAIL_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: TRACK_ORDERS_DETAIL_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR CANCEL ORDER 
export function getOrderCancel(data) {
    return async (dispatch) => {
        dispatch({ type: GET_ORDER_CANCEL_REQUEST });
        try {
            var response = await axiosInstance.post(`web/order-cancel`, data, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            });
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_ORDER_CANCEL_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_ORDER_CANCEL_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_ORDER_CANCEL_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR CANCEL ORDER REASON
export function getOrderCancelReason(data) {
    return async (dispatch) => {
        dispatch({ type: GET_ORDER_CANCEL_REASON_REQUEST });
        try {
            var response = await axiosInstance.post(`web/cancel-reasons`, data, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            });
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_ORDER_CANCEL_REASON_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_ORDER_CANCEL_REASON_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_ORDER_CANCEL_REASON_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR REPORT ISSUE ADD
export function addReportIssue(data) {
    return async (dispatch) => {
        dispatch({ type: ADD_REPORT_ISSUE_REQUEST });
        try {
            var response = await axiosInstance.post(`web/report-issue`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: ADD_REPORT_ISSUE_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: ADD_REPORT_ISSUE_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: ADD_REPORT_ISSUE_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR GET USER DETAILS
export function getUserDetails(data) {
    return async (dispatch) => {
        dispatch({ type: GET_USERDATA_REQUEST });
        try {
            var response = await axiosInstance.post(`web/UserDetail`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: GET_USERDATA_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_USERDATA_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_USERDATA_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}
// FOR EDIT USER DETAILS
export function editUserDetails(data) {
    return async (dispatch) => {
        dispatch({ type: EDIT_USERDATA_REQUEST });
        try {
            const isUrlEncodedPayload =
                typeof URLSearchParams !== "undefined" && data instanceof URLSearchParams;
            var response = await axiosInstance.post(`web/edit-profile`, data, {
                headers: {
                    'Content-Type': isUrlEncodedPayload
                        ? 'application/x-www-form-urlencoded'
                        : 'multipart/form-data',
                },
            });
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: EDIT_USERDATA_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: EDIT_USERDATA_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: EDIT_USERDATA_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}
// FOR GET REPORT ISSUE REASON
export function getReportIssueReason(data) {
    return async (dispatch) => {
        dispatch({ type: GET_REPORT_ISSUE_REASON_REQUEST });
        try {
            var response = await axiosInstance.post(`user/reported-issues`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_REPORT_ISSUE_REASON_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_REPORT_ISSUE_REASON_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_REPORT_ISSUE_REASON_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR GET SOS LIST
export function getSosList(data) {
    return async (dispatch) => {
        dispatch({ type: GET_SOS_LIST_REQUEST });
        try {
            var response = await axiosInstance.post(`user/sos`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: GET_SOS_LIST_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_SOS_LIST_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_SOS_LIST_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR GET REFER DETAILS
export function getReferDetails(data) {
    return async (dispatch) => {
        dispatch({ type: GET_REFER_DETAILS_REQUEST });
        try {
            var response = await axiosInstance.post(`user/refer`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: GET_REFER_DETAILS_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_REFER_DETAILS_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_REFER_DETAILS_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR UPDATE PASSWORD
export function userUpdatePassword(data) {
    return async (dispatch) => {
        dispatch({ type: USER_UPDATE_PASSWORD_REQUEST });
        try {
            var response = await axiosInstance.post(`user/change-password`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: USER_UPDATE_PASSWORD_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: USER_UPDATE_PASSWORD_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: USER_UPDATE_PASSWORD_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// for get product rate
export function getProductRate(data) {
    return async (dispatch) => {
        dispatch({ type: GET_PRODUCT_RATE_REQUEST });
        try {
            var response = await axiosInstance.post(`web/product/rate`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_PRODUCT_RATE_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_PRODUCT_RATE_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_PRODUCT_RATE_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// for get order rate
export function getOrderRate(data) {
    return async (dispatch) => {
        dispatch({ type: GET_ORDER_RATE_REQUEST });
        try {
            var response = await axiosInstance.post(`web/order-rate`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_ORDER_RATE_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_ORDER_RATE_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_ORDER_RATE_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR SAVE PRODUCT CART
export function getSaveProductCart(data, { verifyCart = false, cartId, cartItems } = {}) {
    return async (dispatch, getState) => {
        const segment = getSegmentItems(getState().common?.servicesData).find(
            (item) => String(getSegmentId(item)) === String(data?.segment_id)
        );
        if (isSeparateServiceSegment(data) || isSeparateServiceSegment(segment)) {
            throw new Error("This service uses a separate booking cart.");
        }
        const payload = normalizeSaveCartPayload(data, getActiveUserLocation(getState()).merchant_id);
        // Only CartPage callers explicitly supply a cart ID for this endpoint.
        delete payload.cart_id;
        if (hasValue(cartId)) payload.cart_id = cartId;
        const meta = { verifyCart, cartItems, requestId: ++saveCartRequestSequence };

        dispatch({ type: SAVE_PRODUCT_CART_REQUEST, payload, meta });
        try {
            var response = await axiosInstance.post(`web/save-product-cart`, buildSaveCartFormData(payload));
            var responseJson = response.data;
            if (isSuccessResponse(responseJson) && !isAuthenticationFailure(response)) {
                dispatch({ type: SAVE_PRODUCT_CART_SUCCESS, payload: responseJson, meta });
                if (verifyCart) {
                    const cart = getState().cart;
                    if (cart?.cartItems?.length) {
                        setLocalStorageItem(CART_ID_STORAGE_KEY, cart.cartId);
                    } else {
                        removeLocalStorageItem(CART_ID_STORAGE_KEY);
                    }
                } else {
                    const cart = getState().cart;
                    if (cart?.cartId) {
                        setLocalStorageItem(CART_ID_STORAGE_KEY, cart.cartId);
                    } else {
                        removeLocalStorageItem(CART_ID_STORAGE_KEY);
                    }
                }
                return Promise.resolve(responseJson)
            } else {
                if (verifyCart) removeLocalStorageItem(CART_ID_STORAGE_KEY);
                throw responseJson;
            }
        } catch (error) {
            const authenticationFailed = isAuthenticationFailure(error?.response || { data: error }, error);
            if (authenticationFailed) await dispatch(logOut());
            dispatch({ type: SAVE_PRODUCT_CART_FAILURE, payload: error, meta: { ...meta, authenticationFailed } });
            return Promise.reject(error);
        }
    };
}

export function loadCartPageWithSaveProductCart(context = {}) {
    return async (dispatch, getState) => {
        const state = getState();
        const cartItems = state.cart?.cartItems || [];
        const cartContext = {
            ...parseJsonValue(state.cart?.data?.receipt),
            ...state.cart?.lastSaveCartPayload,
            ...state.cart?.data,
            ...Object.fromEntries(Object.entries(state.cart?.serverCartSummary || {}).filter(([, value]) => hasValue(value))),
            ...context,
        };
        const userLocation = getActiveUserLocation(state);

        // Read the saved server cart without uploading stale local products.
        const payload = {
            single_product: "NO",
            product_update: "NO",
            product_details: null,
            product_variant_id: null,
            quantity: null,
            portion: null,
            empty_bottle_count: null,
            arr_option_id: null,
            segment_id: getDynamicSegmentId(state, cartContext, cartItems),
            business_segment_id: getDynamicBusinessSegmentId(state, cartContext, cartItems),
            merchant_id: getValue(cartContext, ["merchant_id", "merchantId"]) || userLocation.merchant_id,
            latitude: userLocation.latitude,
            longitude: userLocation.longitude,
        };

        return dispatch(getSaveProductCart(payload, { verifyCart: true }));
    };
}

export function refreshCartPageWithSaveProductCart(context = {}) {
    return async (dispatch, getState) => {
        const state = getState();
        const cartId = getActiveCartId(state) || getLocalStorageItem(CART_ID_STORAGE_KEY);

        if (!cartId) {
            dispatch({ type: CART_CLEAR });
            return false;
        }

        setLocalStorageItem(CART_ID_STORAGE_KEY, cartId);
        try {
            await dispatch(loadCartPageWithSaveProductCart(context));
            return Boolean(getState().cart?.cartItems?.length);
        } catch (error) {
            return false;
        }
    };
}

// FOR GET PRODUCT CART
export function getGetProductCart(data) {
    return async (dispatch) => {
        dispatch({ type: GET_PRODUCT_CART_REQUEST });
        try {
            var response = await axiosInstance.post(`web/get-product-cart`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                persistCartIdFromResponse(responseJson);
                dispatch({ type: GET_PRODUCT_CART_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_PRODUCT_CART_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_PRODUCT_CART_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR GET PROMO CODE LIST
export function getPromoCodeList(data) {
    return async (dispatch) => {
        dispatch({ type: GET_PROMO_CODE_LIST_REQUEST });
        try {
            var response = await axiosInstance.post(`web/promo-code-list`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_PROMO_CODE_LIST_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_PROMO_CODE_LIST_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_PROMO_CODE_LIST_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR APPLY REMOVE PROMO CODE
export function applyRemovePromoCode(data) {
    return async (dispatch) => {
        dispatch({ type: APPLY_REMOVE_PROMO_CODE_REQUEST });
        try {
            var response = await axiosInstance.post(`web/grocery/apply-remove-promo-code`, data);
            var responseJson = response.data;
            if ([1, "1"].includes(responseJson?.result)) {
                dispatch({ type: APPLY_REMOVE_PROMO_CODE_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: APPLY_REMOVE_PROMO_CODE_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: APPLY_REMOVE_PROMO_CODE_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR GET CART RELATED ITEM LIST
export function getCartRelatedItemList(data) {
    return async (dispatch) => {
        dispatch({ type: GET_CART_RELATEDITEM_LIST_REQUEST });
        try {
            var response = await axiosInstance.post(`web/cart-related-items`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_CART_RELATEDITEM_LIST_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_CART_RELATEDITEM_LIST_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_CART_RELATEDITEM_LIST_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR GET CATEGORIES LIST
export function getCategoriesList(data) {
    return async (dispatch) => {
        dispatch({ type: GET_CATEGOURIES_REQUEST });
        try {
            var response = await axiosInstance.post(`web/grocery/get-store-categories`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_CATEGOURIES_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_CATEGOURIES_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_CATEGOURIES_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR GET SUBCATEGORIES LIST
export function getSubCategoriesList(data) {
    return async (dispatch) => {
        dispatch({ type: GET_SUBCATEGOURIES_REQUEST });
        try {
            var response = await axiosInstance.post(`web/grocery/get-sub-category`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_SUBCATEGOURIES_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_SUBCATEGOURIES_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_SUBCATEGOURIES_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR GET CATEGORY PRODUCT LIST
export function getCategoryProduct(data) {
    return async (dispatch) => {
        dispatch({ type: GET_CATEGORY_PRODUCT_REQUEST });
        try {
            var response = await axiosInstance.post(`web/grocery/category-products`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_CATEGORY_PRODUCT_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_CATEGORY_PRODUCT_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_CATEGORY_PRODUCT_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// PRODUCT DETAILS
let productDetailRequestSequence = 0;

export function getProductDetails(data) {
    return async (dispatch) => {
        const meta = { requestId: ++productDetailRequestSequence };
        dispatch({ type: GET_PRODUCT_DETAILS_REQUEST, meta });
        try {
            const response = await axiosInstance.post('web/grocery/product/details', data);
            const responseJson = response.data;
            if (!isSuccessResponse(responseJson)) throw responseJson;
            dispatch({ type: GET_PRODUCT_DETAILS_SUCCESS, payload: responseJson, meta });
            return responseJson;
        } catch (error) {
            dispatch({ type: GET_PRODUCT_DETAILS_FAILURE, payload: error, meta });
            throw error;
        }
    };
}

// FOR PLACE ORDER
export function getPlaceOrder(data) {
    return async (dispatch) => {
        dispatch({ type: PLACE_ORDER_REQUEST });
        try {
            var response = await axiosInstance.post(`web/grocery/place-order`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: PLACE_ORDER_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson);
            } else {
                dispatch({ type: PLACE_ORDER_FAILURE, payload: responseJson });
                return Promise.reject(responseJson);
            }
        } catch (error) {
            dispatch({ type: PLACE_ORDER_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// FOR RETURN ITEM
export function reOrder(data) {
    return async (dispatch) => {
        dispatch({ type: RE_ORDER_REQUEST });
        try {
            var response = await axiosInstance.post(`web/re-order`, data, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            });
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: RE_ORDER_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: RE_ORDER_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: RE_ORDER_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}
 
//GET ITEMS FOR RETURN
export function getItemsForReturn(data) {
    return async (dispatch) => {
        dispatch({ type: GET_ITEMS_FOR_RETURN_REQUEST });
        try {
            var response = await axiosInstance.post(`web/get-items-for-return`, data, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            });
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: GET_ITEMS_FOR_RETURN_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_ITEMS_FOR_RETURN_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_ITEMS_FOR_RETURN_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

//FOR RETURN ITEM
export function returnItems(data) {
    return async (dispatch) => {
        dispatch({ type: RETURN_ITEMS_REQUEST });
        try {
            var response = await axiosInstance.post(`web/return-items`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: RETURN_ITEMS_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: RETURN_ITEMS_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: RETURN_ITEMS_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

//FOR VIEW SUBSITUTION DETAIL
export function viewSubsititutionDetail(data) {
    return async (dispatch) => {
        dispatch({ type: VIEW_SUBSITUTION_DETAIL_REQUEST });
        try {
            var response = await axiosInstance.post(`user/grocery/view-substitution-details`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: VIEW_SUBSITUTION_DETAIL_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: VIEW_SUBSITUTION_DETAIL_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: VIEW_SUBSITUTION_DETAIL_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

//FOR SUBMIT SUBSITUTION DATA
export function submitSubsititutionData(data) {
    return async (dispatch) => {
        dispatch({ type: SUBMIT_SUBSITUTION_DETAIL_REQUEST });
        try {
            var response = await axiosInstance.post(`user/grocery/substitution-details/submit`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: SUBMIT_SUBSITUTION_DETAIL_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: SUBMIT_SUBSITUTION_DETAIL_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: SUBMIT_SUBSITUTION_DETAIL_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// LOGOUT 
export function logOut() {
    return async dispatch => {
        dispatch({ type: LOGOUT_REQUEST, payload: 'Logout_Request' })
        try {
            if (typeof window !== "undefined") {
                const selectedEnvironment = localStorage.getItem(API_ENV_STORAGE_KEY);
                localStorage.clear();
                if (selectedEnvironment) {
                    localStorage.setItem(API_ENV_STORAGE_KEY, selectedEnvironment);
                }
                localStorage.setItem('forceLogout', String(Date.now()));
            }
            dispatch({ type: LOGOUT_SUCCESS, payload: 'Logout_Success' })
            dispatch({ type: RESET_DATA });
        }
        catch (e) {
            dispatch({ type: LOGOUT_FAILURE, payload: 'Logout_Failure' })
        }
    }
}

// LOCAL CART
export function addCartItem(data, { cartId, replaceCart = false } = {}) {
    return async (dispatch, getState) => {
        const state = getState();
        if (state.cart?.saveCartLoading || state.cart?.getCartLoading) return null;
        const item = normalizeCartItem(data);

        if (!item.id) {
            return null;
        }

        const cartItems = replaceCart ? [] : (state.cart?.cartItems || []).map(normalizeCartItem);
        const nextCartItems = getNextCartItemsAfterAdd(cartItems, item);
        return saveCartAfterLocalChange({
            dispatch,
            state,
            nextCartItems,
            changedItem: item,
            cartId,
        });
    };
}

export function removeCartItem(id, { cartId } = {}) {
    return async (dispatch, getState) => {
        const state = getState();
        if (state.cart?.saveCartLoading || state.cart?.getCartLoading) return null;
        const cartItems = (state.cart?.cartItems || []).map(normalizeCartItem);
        const removedItem = cartItems.find((item) => getItemId(item) === String(id));
        const nextCartItems = cartItems.filter((item) => getItemId(item) !== String(id));
        const wasCartExisting = Boolean(getActiveCartId(state) || cartItems.length);

        if (!removedItem || !wasCartExisting) {
            return null;
        }

        return saveCartAfterLocalChange({
            dispatch,
            state,
            nextCartItems,
            changedItem: { ...removedItem, quantity: 0 },
            cartId,
        });
    };
}

export function updateCartItemQuantity(id, quantity, { cartId } = {}) {
    return async (dispatch, getState) => {
        const state = getState();
        if (state.cart?.saveCartLoading || state.cart?.getCartLoading) return null;
        const cartItems = (state.cart?.cartItems || []).map(normalizeCartItem);
        const currentItem = cartItems.find((item) => getItemId(item) === String(id));
        const nextQuantity = Math.max(1, Number(quantity || 1));
        const nextCartItems = cartItems.map((item) =>
            getItemId(item) === String(id)
                ? { ...item, quantity: nextQuantity }
                : item
        );
        const wasCartExisting = Boolean(getActiveCartId(state) || cartItems.length);

        if (!currentItem || !wasCartExisting) {
            return null;
        }

        return saveCartAfterLocalChange({
            dispatch,
            state,
            nextCartItems,
            changedItem: { ...currentItem, quantity: nextQuantity },
            cartId,
        });
    };
}

export function updateCartItemPortion(id, { portion, price }, { cartId } = {}) {
    return async (dispatch, getState) => {
        const state = getState();
        if (state.cart?.saveCartLoading || state.cart?.getCartLoading) return null;
        const cartItems = (state.cart?.cartItems || []).map(normalizeCartItem);
        const currentItem = cartItems.find((item) => getItemId(item) === String(id));
        if (!currentItem || !hasValue(portion)) return null;

        const changedItem = { ...currentItem, portion, price };
        const nextCartItems = cartItems.map((item) =>
            getItemId(item) === String(id) ? changedItem : item
        );
        return saveCartAfterLocalChange({
            dispatch,
            state,
            nextCartItems,
            changedItem,
            cartId,
        });
    };
}

export function clearCart() {
    return (dispatch) => {
        removeLocalStorageItem(CART_ID_STORAGE_KEY);
        dispatch({
            type: CART_CLEAR
        });
    };
}


// for Get user address list
export function getUserAddress(data) {
    return async (dispatch) => {
        dispatch({ type: TRIGGERS_LIST_UNDER_REQUEST });
        try {
            var response = await axiosInstance.post(`web/get-address`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: TRIGGERS_LIST_UNDER_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: TRIGGERS_LIST_UNDER_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: TRIGGERS_LIST_UNDER_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// for add user address
export function addUserAddress(data) {
    return async (dispatch) => {
        dispatch({ type: TRIGGERS_CREATE_REQUEST });
        try {
            var response = await axiosInstance.post(`web/add-address`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: TRIGGERS_CREATE_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: TRIGGERS_CREATE_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: TRIGGERS_CREATE_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// for update user address
export function updateUserAddress(data) {
    return async (dispatch) => {
        dispatch({ type: TRIGGERS_UPDATE_REQUEST });
        try {
            var response = await axiosInstance.post(`web/add-address`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: TRIGGERS_UPDATE_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: TRIGGERS_UPDATE_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: TRIGGERS_UPDATE_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// for delete user address
export function deleteUserAddress(data) {
    return async (dispatch) => {
        dispatch({ type: TRIGGERS_DELETE_REQUEST });
        try {
            var response = await axiosInstance.post(`web/delete-address`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: TRIGGERS_DELETE_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: TRIGGERS_DELETE_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: TRIGGERS_DELETE_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}
// CHANGE PASSWORD
export function changePassword(data) {
    return async (dispatch) => {
        dispatch({ type: CHANGE_PASSWORD_REQUEST });
        try {
            var response = await axiosInstance.post(`web/change-password`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: CHANGE_PASSWORD_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: CHANGE_PASSWORD_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: CHANGE_PASSWORD_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// EDIT PROFILE
export function editProfile(data) {
    return async (dispatch) => {
        dispatch({ type: EDIT_PROFILE_REQUEST });
        try {
            var response = await axiosInstance.post(`web/web/edit-profile`, data);
            var responseJson = response.data;
            if (responseJson?.result) {
                dispatch({ type: EDIT_PROFILE_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: EDIT_PROFILE_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: EDIT_PROFILE_FAILURE, payload: error });
            return Promise.reject(error);
        }
    };
}

// GET SOCIAL LINKS
export function getSocialLinks(data = { merchant_id: 1 }) {
    return (dispatch) => shareReadRequest(dispatch, "user/social-links", data, async () => {
        dispatch({ type: GET_SOCIAL_LINKS_REQUEST });
        try {
            var response = await axiosInstance.post(`user/social-links`, data);
            var responseJson = response.data;
            if (isSuccessResponse(responseJson)) {
                dispatch({ type: GET_SOCIAL_LINKS_SUCCESS, payload: responseJson });
                return Promise.resolve(responseJson)
            } else {
                dispatch({ type: GET_SOCIAL_LINKS_FAILURE, payload: responseJson });
                return Promise.reject(responseJson)
            }
        } catch (error) {
            dispatch({ type: GET_SOCIAL_LINKS_FAILURE, payload: error });
            return Promise.reject(error);
        }
    });
}

// ✅ SET USER LOCATION (GLOBAL)
export function setLocation(data) {
    return (dispatch) => {
        const locationData = enrichLocationWithMarketMetadata(data || {});

        // ✅ localStorage me save (important)
        localStorage.setItem(LOCATION_STORAGE_KEY, JSON.stringify(locationData));
        if (typeof window !== "undefined") {
            window.dispatchEvent(new CustomEvent("user-location-change", { detail: locationData }));
        }

        dispatch({
            type: SET_LOCATION,
            payload: locationData
        });
    };
}

export function openModal(modalId) {
    return (dispatch) => {
        dispatch({ type: OPEN_MODAL, payload: modalId });
    }
};
export function closeModal(modalId) {
    return (dispatch) => {
        dispatch({ type: CLOSE_MODAL, payload: modalId });
    }
};
export function closeAllModals() {
    return (dispatch) => {
        dispatch({ type: CLOSE_ALL_MODALS });
    }
};
